import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('package_code'),
	fieldsMap.get('package_description')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
